module.exports = __webpack_public_path__ + "static/img/impacta2.f2615926.svg";